import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import ChannelContext from '@jetshop/core/components/ChannelContext';

const Outer = styled('div')`
  margin: auto;
  width: 100%;
  max-width: 640px;
  height: 100%;
  max-height: 640px;
`;

const Wrapper = styled('div')`
  position: relative;
  padding-bottom: 100%;
  height: 0;
  overflow: hidden;
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function Youtube({ src }) {
  const videoId = src.split('?v=')[1];
  return (
    <Outer>
      <Wrapper>
        <iframe
          title="Video"
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&loop=1&playlist=${videoId}&modestbranding=1&playsinline=1&rel=0&mute=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Wrapper>
    </Outer>
  );
}

function Vimeo({ src }) {
  const videoId = src.split('video/')[1];
  return (
    <Outer>
      <Wrapper style={{ paddingBottom: '56.25%' }}>
        <iframe
          title="Video"
          width="560"
          height="315"
          src={`https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&autopause=0&muted=1&playsinline=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Wrapper>
    </Outer>
  );
}

export const Internal = ({ src }) => {
  const { selectedChannel } = useContext(ChannelContext);

  if (!src) {
    return null;
  }

  return (
    <video
      width="100%"
      muted
      autoPlay
      controls
      loop
      playsInline
      webkit-playsInline
      webKitplaysInline
    >
      <source src={`${selectedChannel.url}${src}`} type="video/mp4" />
    </video>
  );
};

export const Iframes = {
  Youtube: src => <Youtube src={src} />,
  Vimeo: src => <Vimeo src={src} />,
  Internal: src => <Internal src={src} />
};
